import * as React from 'react';
import styles from './styles/Tabs.css';

interface ITabAdditionalInfoProps {
	title: string;
	counter?: string | number;
	percentageInfo?: string;
}

export const TabAdditionalInfo: React.FC<ITabAdditionalInfoProps> = (props) => {
	const renderPercentageInfo = () => {
		return (
			<div className={styles.percentageResult}>
				<span>{props.percentageInfo}</span>
			</div>
		);
	};

	return (
		<div className={styles.customTabWrapper}>
			<div className={styles.customTitle}>{props.title}</div>
			<div className={styles.counter}>{props.counter}</div>
			{props.percentageInfo && renderPercentageInfo()}
		</div>
	);
};
